var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.66667C6.8 6.55556 8.8 5 12 5C16.8 5 17.4 8.5 19.8 9.08333C21.4 9.47222 22.8 8.88889 24 7.33333C23.2 10.4444 21.2 12 18 12C13.2 12 12.6 8.5 10.2 7.91667C8.6 7.52778 7.2 8.11111 6 9.66667ZM0 16.6667C0.8 13.5556 2.8 12 6 12C10.8 12 11.4 15.5 13.8 16.0833C15.4 16.4722 16.8 15.8889 18 14.3333C17.2 17.4444 15.2 19 12 19C7.2 19 6.6 15.5 4.2 14.9167C2.6 14.5278 1.2 15.1111 0 16.6667Z",
    fill: "#44A8B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.ea2ad4b65f644e55be4a79b6f7bc887d.svg";
export { ForwardRef as ReactComponent };